import { BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';

export function handleModalStatus({
  type = 'success',
  titleOnSuccess = 'Sucesso',
  titleOnError = 'Erro',
  msgOnSuccess = 'Registro alterado com sucesso.',
  msgOnError = 'Houve um erro ao tentar realizar essa ação, tente novamente.',
  msgOnHasExist = 'Este tipo de registro já existe. É necessário que você defina um tipo diferente para continuar.',
  onCloseModal = () => {},
  showModal = (config) => {},
}) {
  const labelOk = 'OK';
  const successResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: 'primary',
        color: BaSeTheme.colors.feedbackInterface.sucesso20,
      },
    ],
    title: titleOnSuccess,
    titleColor: BaSeTheme.colors.institucionais.cinzaSebrae45,
    dismissable: true,
    content: () => (
      <BaSeParagraph
        isBold={true}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {msgOnSuccess}
      </BaSeParagraph>
    ),
    onDismiss: () => onCloseModal(),
    onChooseAction: () => onCloseModal(),
  };

  const errorResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: 'primary',
        color: BaSeTheme.colors.feedbackInterface.informacao,
      },
    ],
    title: titleOnError,
    titleColor: BaSeTheme.colors.feedbackInterface.erro45,
    dismissable: true,
    content: () => (
      <BaSeParagraph
        isBold={true}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {msgOnError}
      </BaSeParagraph>
    ),
    onChooseAction: () => onCloseModal(),
  };

  const errorHasExistResponseConfig = {
    actions: [
      {
        action: labelOk,
        type: 'primary',
        color: BaSeTheme.colors.feedbackInterface.informacao,
      },
    ],
    title: titleOnError,
    titleColor: BaSeTheme.colors.feedbackInterface.erro45,
    dismissable: true,
    content: () => (
      <BaSeParagraph
        isBold={true}
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
      >
        {msgOnHasExist}
      </BaSeParagraph>
    ),
    onChooseAction: () => onCloseModal(),
  };
  const config =
    type === 'success'
      ? successResponseConfig
      : type === 'hasExist'
      ? errorHasExistResponseConfig
      : errorResponseConfig;
  showModal(config);
}
